"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var clause_1 = require("./../clause");
var lodash_1 = require("lodash");
var Where = /** @class */ (function (_super) {
    __extends(Where, _super);
    function Where() {
        return _super.call(this) || this;
    }
    Where.prototype.addComponent = function (triple) {
        this._components.push(triple);
    };
    Where.prototype.build = function () {
        var selected = lodash_1.map(this._components, function (item) {
            if (item instanceof clause_1.Clause) {
                return item.build();
            }
            return item;
        });
        return "WHERE{\n" + selected.slice().join(' .\n') + "\n}\n";
    };
    return Where;
}(clause_1.Clause));
exports.Where = Where;
